const appGlobalProps = global.appGlobalProps || {}

export const locale = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : 'en-us'
export const location = locale.toLocaleLowerCase()
export const language = location.split('-')[0]
export const region = location.split('-')[1]

export const contentApi = process.env.VUE_APP_CONTENT_API
export const zimbaApi = process.env.VUE_APP_ZIMBA_API
export const assetsUrl = appGlobalProps.assetsUrl || process.env.VUE_APP_ASSETS_URL
export const pageId = appGlobalProps.pageId
export const categoryId = appGlobalProps.categoryId
export const hotelCode = appGlobalProps.hotelCode

export const tridionLabels = window.tridionLabels || {}
